import { render } from "./OrderStatusPage.vue?vue&type=template&id=baade1ae&scoped=true"
import script from "./OrderStatusPage.vue?vue&type=script&lang=js"
export * from "./OrderStatusPage.vue?vue&type=script&lang=js"

import "./OrderStatusPage.vue?vue&type=style&index=0&id=baade1ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baade1ae"]])

export default __exports__